module.exports = __webpack_public_path__ + "static/media/swipe-card.50586be2.gif";